import type { Chart, IAxisLabelRenderEventArgs } from '@syncfusion/ej2-charts';

interface CaloriesDataItem {
    Date: string;
    Actual: number;
    Target: number;
}

export async function caloriesComparisonChart(appendTo: string, data: CaloriesDataItem[], title: string, fill: string) {

    await import('./loadSyncfusion');

    const { Chart, LineSeries, Category, Tooltip, Legend } = await import('@syncfusion/ej2-charts');

    Chart.Inject(LineSeries, Category, Tooltip, Legend);

    const commonFont = { color: '#fff', fontFamily: 'Helvetica' };

    const chart: Chart = new Chart({
        primaryXAxis: {
            valueType: 'Category',
            majorGridLines: { width: 0 },
            labelStyle: commonFont,
            titleStyle: commonFont,
            labelIntersectAction: 'Hide',
            title: 'Date'
        },
        primaryYAxis: {
            majorGridLines: { width: 1, color: '#777' },
            lineStyle: { width: 0 },
            labelStyle: commonFont,
            titleStyle: commonFont,
            title: title
        },
        series: [
            {
                type: 'Line',
                dataSource: data,
                xName: 'Date',
                yName: `Actual`,
                name: `Actual ${title}`,
                marker: { visible: true },
                width: 2,
                fill: fill,
                animation: { enable: false }
            },
            {
                type: 'Line',
                dataSource: data,
                xName: 'Date',
                yName: `Target`,
                name: `Target ${title}`,
                marker: { visible: false },
                width: 2,
                dashArray: '5,5',
                fill: '#FF0000',
                animation: { enable: false }
            }
        ],
        tooltip: {
            enable: true,
            format: '${point.x}: ${series.name}: ${point.y} kcal'
        },
        legendSettings: {
            visible: true,
            textStyle: commonFont
        },
        background: '#3A3A3A',
        width: '100%',
        height: '100%',
        axisLabelRender: (args: IAxisLabelRenderEventArgs) => {
            if (args.axis.name === 'primaryXAxis') {
                const date = new Date(args.text);
                const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
                args.text = date.toLocaleDateString('en-NZ', options);
            }
        }
    });

    chart.appendTo(appendTo);

    return chart;
}
